import React from "react";
import { AuthLayout } from "../../layout";
import { Card } from "antd";
import { PureLoginForm } from "../../components/Forms";
import { Footer } from "../../components";

import LoginBg from "../../assets/loginImg.JPG";

const LoginPage = () => {
  return (
    <AuthLayout>
      <div className="flex text-center justify-evenly px-0 xl:px-0 2xl:px-0 auth-container">
        <div className="hidden lg:block mt-40">
          <img src={LoginBg} width={400} />
        </div>
        <div className="w-full lg:w-3/4 xl:w-5/12 2xl:w-2/6">
          <Card className="shadow-lg login-card auth-card p-9 shadow-sm">
            <PureLoginForm page={true} />
          </Card>
          <Footer />
        </div>
      </div>
    </AuthLayout>
  );
};

export default LoginPage;
